import React from 'react';
import VoucherPage from './VoucherPage';

const WordpressHostingPage: React.FC = () => {
  return <VoucherPage category="wordpressHosting" />;
};

export default WordpressHostingPage;
